import { execOnLoad } from '@general/helpers';
import './designers.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSlideshow = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const containers = context.querySelectorAll('.designers__list-container');

  containers.forEach((container) => {
    const items = Array.from(
      container.querySelectorAll('.designers__brand-name'),
    );
    const grouped = items
      .map((item) => {
        const text = item.textContent.trim();
        const firstChar = text[0].toUpperCase();
        const group = /^[0-9]/.test(firstChar) ? '1.' : firstChar;
        return { element: item, text, group };
      })
      .sort((a, b) => a.text.localeCompare(b.text))
      .reduce((acc, { element, group }) => {
        acc[group] = acc[group] || [];
        acc[group].push(element);
        return acc;
      }, {});

    const sortedGroups = Object.keys(grouped).sort((a, b) => {
      if (a === '1.') return -1;
      if (b === '1.') return 1;
      return a.localeCompare(b);
    });

    container.innerHTML = '';
    sortedGroups.forEach((group) => {
      const groupBlock = document.createElement('div');
      groupBlock.classList.add('designers__group');

      const groupTitle = document.createElement('div');
      groupTitle.classList.add('designers__letter');
      groupTitle.textContent = group;
      groupBlock.appendChild(groupTitle);

      const brandContainer = document.createElement('div');
      brandContainer.classList.add('designers__brand-container');

      grouped[group].forEach((item) => brandContainer.appendChild(item));
      groupBlock.appendChild(brandContainer);

      container.appendChild(groupBlock);
    });
  });

  const buttons = context.querySelectorAll('.designers__cta .btn');

  if (buttons) {
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetList = button.getAttribute('data-list');

        buttons.forEach((insideButton) => {
          var insideButtonList = insideButton.getAttribute('data-list');
          if (targetList == insideButtonList) {
            insideButton.classList.add('active');
          } else {
            insideButton.classList.remove('active');
          }
        });

        containers.forEach((container) => {
          if (container.getAttribute('data-list') === targetList) {
            container.style.display = 'block';
          } else {
            container.style.display = 'none';
          }
        });
      });
    });
  }
};

execOnLoad(window.dAgency.initSlideshow, '.designers__section');
